// Inside the file where StudentLinks is defined, e.g., StudentLinks.js

import React, { useContext } from 'react';
import { BsKanban } from 'react-icons/bs';
import { IoMdContacts } from 'react-icons/io';
import { useAuth } from '../hooks/useauth';

const StudentLinks = () => {
  const { currentUser, logout } = useAuth()

  const handleLogout = async () => {
    try {
      await logout();
      // Additional logic after successful logout, e.g., navigate to the login page
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    [
      {
        title: 'My Learning',
        links: [
          {
            name: 'All Courses',
            icon: <BsKanban />,
            route: 'my-learning',
          },
          {
            name: 'My Courses',
            icon: <IoMdContacts />,
            route: 'my-courses',
          },
          {
            name: 'Placeholder',
            icon: <IoMdContacts />,
            route: 'place',
          },
          {
            name: 'Match Them',
            icon: <IoMdContacts />,
            route: 'match',
          },
          {
            name: 'Quiz',
            icon: <IoMdContacts />,
            route: 'takequiz',
          },
          {
            name: 'Logout',
            icon: <IoMdContacts />,
            route: 'logout',
          },
        ],
      },
    ]
  );
};

export default StudentLinks; // Export StudentLinks
